import React from 'react';
import styled from 'styled-components/macro';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const SLayout = styled.span`
    height: 20px;
    width: 20px;
    user-select: none;
`;

const SText = styled.span`
    font-size: ${(props) => props.fontSize}px;
    color: #6495ed;
    font-weight: bold;
    padding-bottom: 1px;
    white-space: pre-wrap;
`;

const SAbsolute = styled.div`
    position: absolute;
    top: -5px;
    left: 0;
`;

const TipsIcon = ({
    messages = [],
    title,
    style = {},
    placement = '',
    removeBracket = false,
    label = '?',
    fontSize = 11,
    iconStyle = false,
}) => {
    const getText = () => {
        if (removeBracket) {
            return <SText fontSize={fontSize}>{label}</SText>;
        }

        return <SText fontSize={fontSize}>({label})</SText>;
    };

    const extra = {};

    if (placement) {
        extra.placement = placement;
    }

    return (
        <SLayout style={{ color: '#3F51B5', position: 'relative', marginLeft: 3, ...style }}>
            <Tooltip
                fontSize={16}
                title={
                    <div style={{ fontSize: 12, padding: 3, lineHeight: 1.5 }}>
                        {title}
                        {messages.map((item, index) => {
                            return (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    {item}
                                </div>
                            );
                        })}
                    </div>
                }
                {...extra}
            >
                <span>
                    {iconStyle ? (
                        <InfoIcon style={{color: '#808080'}}  />
                    ) : (
                        <>
                            <span style={{ opacity: 0 }}>{getText()}</span>
                            <SAbsolute>{getText()}</SAbsolute>
                        </>
                    )}
                </span>
            </Tooltip>
        </SLayout>
    );
};

export default TipsIcon;
